import React from 'react';
import { ChevronLeft, ChevronRight } from "lucide-react";
import { getPageNumbers } from 'utils';
import { PaginationBarProps } from 'types';

const PaginationBar: React.FC<PaginationBarProps> = ({
  page,
  totalPages,
  pageSize,
  pageSizeOptions,
  onPrev,
  onNext,
  onGoToPage,
  onPageSizeChange,
}) => {
  const pages = getPageNumbers(page, totalPages);

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-1">
        <button
          onClick={onPrev}
          disabled={page === 1}
          className="pagination-arrow"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        {pages.map((p, index) =>
          p === "..." ? (
            <span
              key={`dots-${page}-${index}`}
              className="px-2 text-sm text-gray-500"
            >
              ...
            </span>
          ) : (
            <button
              key={`page-${p}-${index}`}
              onClick={() => onGoToPage(p)}
              className={`pagination-page ${p === page ? "pagination-active" : ""
                }`}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={onNext}
          disabled={page === totalPages}
          className="pagination-arrow"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <span>Số dòng/trang</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="h-8 rounded-md border border-gray-300 bg-white px-2
                     text-sm focus:border-blue-500 focus:outline-none"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PaginationBar;
